import classNames from 'classnames';
import React, { forwardRef, Ref } from 'react';
import { NavLink, NavLinkProps, useMatch } from 'react-router-dom';
import { UDTextType } from '../text';

export type IUDNavLinkProps = {
  type?: UDTextType;
  disabled?: boolean;
  checkPath?: string;
  variant?: 'primary' | 'secondary';
} & NavLinkProps;

const UDNavLink = forwardRef<HTMLAnchorElement, IUDNavLinkProps>((props: IUDNavLinkProps, ref: Ref<HTMLAnchorElement>) => {
  const { type = 'callout', disabled, className, checkPath, variant = 'primary', ...otherProps } = props;

  const { to } = otherProps;
  const url = checkPath ?? (typeof to === 'string' ? to : to.pathname);
  const isActive = useMatch(url ?? '');

  return (
    <NavLink
      {...otherProps}
      ref={ref}
      className={() =>
        classNames('link', 'text', type, className, variant, {
          disabled,
          active: isActive,
        })
      }
    />
  );
});

// Добавляем отображаемое имя для улучшения отладки
UDNavLink.displayName = 'UDNavLink';

export default UDNavLink;
